import { render, staticRenderFns } from "./ShipmentsReports.vue?vue&type=template&id=6812691b&"
import script from "./ShipmentsReports.vue?vue&type=script&lang=js&"
export * from "./ShipmentsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports